import { render, staticRenderFns } from "./topicTitle.vue?vue&type=template&id=333a4958&scoped=true&"
import script from "./topicTitle.vue?vue&type=script&lang=js&"
export * from "./topicTitle.vue?vue&type=script&lang=js&"
import style0 from "./topicTitle.vue?vue&type=style&index=0&id=333a4958&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333a4958",
  null
  
)

export default component.exports